import type { ChannelBundleDtoBundleSingleView } from '@bldsoft/cappie/api/wbs'
import type { PurchaseInfo, TvBundleInfo } from '@setplex/tria-api'

import { getBackgroundImage, getHorizontalImage } from '../../utils/images'
import { formatPriceSettings } from '../../utils/payment'

export const formatTvBundle = (
  bundle: ChannelBundleDtoBundleSingleView
): TvBundleInfo => {
  return {
    id: bundle.id!,
    name: bundle.name!,
    description: bundle.description,
    landscapeImageUrl: getHorizontalImage(bundle.coverImageUrl),
    backgroundImageUrl: getBackgroundImage(bundle.coverImageUrl),
    purchaseInfo: bundle.purchaseInfo as PurchaseInfo,
    channelIds: bundle.channelIds!,
    contentQuantity: bundle.contentQuantity!,
    updatedTime: bundle.updatedTime!,
    priceSettings: formatPriceSettings(bundle.priceSettings) || [],
    free: bundle?.priceSettings?.length === 0,
    externalId: bundle.externalId,
  } as TvBundleInfo
}
